import { Component, Input, Output } from '@angular/core';
import { IAbstractView, ILanguageObject } from '@core/interfaces';
import { TermsConditionsPresenter } from './terms-conditions.presenter';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { ITermsConditionsComponent, ITermsConditionsPresenter } from './interfaces';
import { DialogComponent, TabsComponent, ScrollContainerComponent } from '@shared/components';
import { ITabItem } from '../tabs/interfaces';

@Component({
	selector: 'app-terms-conditions',
	templateUrl: './terms-conditions.component.html',
	styleUrls: ['./terms-conditions.component.scss'],
	standalone: true,
	imports: [
		CommonModule, 
		IonicModule, 
		FormsModule, 
		DialogComponent,
		TabsComponent,
		ScrollContainerComponent
	],
})
export class TermsConditionsComponent
	extends IAbstractView<ITermsConditionsPresenter>
	implements ITermsConditionsComponent
{
	selectedTab = this.presenter.selectedTab;
	accountSlug = this.presenter.accountSlug;
	
	private _translations: ILanguageObject = {};
	get translations(): ILanguageObject {
		return this._translations;
	}
	set translations(value: ILanguageObject) {
		this._translations = value;
		if (value) {
			this.tabs = [
				{ value: 'terms', label: value['title'] },
				{ value: 'shipping', label: value['titleShippingAndDeliveryPolicies'] },
				{ value: 'privacy', label: value['titlePrivacyPolicies'] }
			];
		}
	}

	tabs: ITabItem[] = [];

	@Input() showAcceptButtons = this.presenter.showAcceptButtons;
	@Output() accepted = this.presenter.accepted;
	@Output() declined = this.presenter.declined;

	constructor(presenter: TermsConditionsPresenter) {
		super(presenter);
		this.translations = this.presenter.translations;
	}

	onTabChanged(event: string): void {
		this.presenter.onTabChanged(event);
	}

	onAccept(): void {
		this.presenter.onAccept();
	}

	onDecline(): void {
		this.presenter.onDecline();
	}

	dismiss(): void {
		this.presenter.dismiss();
	}
}
